
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.294 5.175l9.091 6.347-8.985 6.23c-.368.261-.593.336-.84.128-.226-.19-.191-.586-.126-.894l.052-.21 1.002-3.237h-1.317A3.168 3.168 0 0013 16.706v8.293a1.996 1.996 0 01-1.847 1.991l-.158.006a2 2 0 01-1.996-2v-8.171a7.287 7.287 0 017.29-7.283h1.215l-1.019-3.318-.052-.21c-.065-.308-.1-.705.126-.894.222-.187.427-.145.734.055z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    